//
// secutil.js
//
import globals from '../models/globals';
import HmacSHA256 from 'crypto-js/hmac-sha256';
import Base64 from 'crypto-js/enc-base64';

export function beginWidgetSession(widgetSessionKey){
    if(widgetSessionKey){
        var parts = widgetSessionKey.split(':');
        if(parts.length === 3){
            globals.widgetSessionId = parts[0].trim();
            globals.widgetSessionSecret = parts[1].trim();
            const serverTimestamp = parts[2].trim();
            globals.clockOffset = serverTimestamp? parseInt(serverTimestamp) - new Date().getTime() : 0;
        }else{
            console.error('bad session key');
        }
    }
}

export function generateSessionToken(){
    if(globals.widgetSessionId && globals.widgetSessionSecret){
        var timestamp = String(new Date().getTime() + globals.clockOffset);
        var payload =  'GET-INFO-WIDGET:' + timestamp;
        var hash = hmacSha256(payload, globals.widgetSessionSecret);
        var token = globals.widgetSessionId + ':' + timestamp + ':' + hash;
        return token;
    }else{
        return '';
    }
}

export function hmacSha256(payload, key){
    var hash = HmacSHA256(payload, key);
    var hashB64 = Base64.stringify(hash);
    return hashB64;
}

export function getRequestTracker(messageId, originatorId, transactionId){
    if(originatorId && transactionId){
        return originatorId + ':' + transactionId + ':' + messageId;
    }else{
        return '';
    }
}



// WEBPACK FOOTER //
// ./application/src/utilities/secutil.js